import React from 'react';
import {concatenate} from "../../../services/string";

// Helpers ----

const colorClasses = {
    light: 'text-white',
    dark: 'text-gray-700',
    neutral: 'text-gray-500',
}

// Types ----

export type LabelColor = 'light' | 'dark' | 'neutral'

type LabelProps = {
    htmlFor?: string
    children: React.ReactNode
    color?: LabelColor
}

// Component ----

function Label(props: LabelProps) {
    const {htmlFor, children, color = 'dark'} = props

    return (
        <label htmlFor={htmlFor} className={concatenate("block text-sm", colorClasses[color])}>
            {children}
        </label>
    );
}

export default Label;